import {BANNER} from './BannerTypes'

const initialState = {
    banner : false
}

const BannerReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case BANNER:
            
            return {
                banner : action.load
            }
    
        default:
          return state
    }

}

export default BannerReducer;